import type { UserInfo } from "./GlobalType";

/** 未设置展示昵称时（含仅空白）需先补全资料。 */
export function isNicknameMissing(user: UserInfo | null | undefined): boolean {
  if (user == null) {
    return false;
  }
  return !String(user.name ?? "").trim();
}
